import React, { useState } from "react";
import { db } from "../Firebase/firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../Assets/logo512.png";

const Certificate = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [certificateData, setCertificateData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!searchTerm) {
      setError("Please enter a valid email or phone number.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const queryRef = query(
        collection(db, "chess-customer-registrations"),
        where("email", "==", searchTerm)
      );

      const querySnapshot = await getDocs(queryRef);

      if (querySnapshot.empty) {
        const phoneQueryRef = query(
          collection(db, "chess-customer-registrations"),
          where("phone", "==", searchTerm)
        );

        const phoneQuerySnapshot = await getDocs(phoneQueryRef);

        if (phoneQuerySnapshot.empty) {
          setCertificateData(null);
          setError("No customer found for this email or phone number.");
        } else {
          const customerData = phoneQuerySnapshot.docs.map((doc) => doc.data());
          setCertificateData(customerData[0]);
        }
      } else {
        const customerData = querySnapshot.docs.map((doc) => doc.data());
        setCertificateData(customerData[0]);
      }
    } catch (error) {
      setError("Error fetching data. Please try again later.");
    }

    setLoading(false);
  };

  const downloadPDF = async () => {
    const certificateElement = document.getElementById("certificate");
  
    if (!certificateElement) return;
  
    window.scrollTo(0, 0);
  
    const canvas = await html2canvas(certificateElement, {
      scale: 2,
      useCORS: true,
    });
  
    const imgData = canvas.toDataURL("image/png");
  
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [150, 100],
    });
  
    pdf.addImage(imgData, "PNG", 0, 0, 150, 100); // match size here
    pdf.save(`${certificateData.first_name}_${certificateData.last_name}_certificate.pdf`);
  };

  return (
    <Layout>
      <Header heading="Prize Money Cross Country Race" showBackButton={true} />
      <div className="flex items-center justify-center p-4">
        <div className="bg-white shadow-xl rounded-xl border-2 border-[#df670e] w-full max-w-3xl p-2">
          <h4 className="text-2xl font-bold text-[#df670e] text-center mb-4">
            Search Your Certificate
          </h4>
          <form onSubmit={handleSearch} className="text-center mb-4">
            <input
              type="text"
              placeholder="Enter Email or Phone"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="p-3 border rounded-md w-full max-w-sm mb-4"
            />
            <br />
            <button
              type="submit"
              className="bg-[#df670e] text-white py-2 px-6 rounded-md font-semibold"
            >
              Search
            </button>
          </form>
          {loading && <p className="text-center">Loading...</p>}
          {error && <p className="text-center text-red-500">{error}</p>}
        </div>
      </div>

      {certificateData && (
        <div className="flex flex-col items-center justify-center">
          <div
            id="certificate"
            className="relative w-[150mm] h-[100mm] bg-[#fff4e6]"
          >
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#fff4e6] shadow-lg rounded-lg border-2 border-[#df670e] w-[140mm] h-[90mm] flex flex-col justify-between p-4">

              {/* Watermark */}
              <div className="absolute inset-0 flex items-center justify-center z-0 pointer-events-none select-none">
                <img
                  src={logo}
                  alt="Watermark Logo"
                  className="w-[50mm] h-auto opacity-30"
                />
              </div>

              {/* Ribbon */}
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#df670e] text-white px-4 py-1 rounded-full text-base font-semibold shadow z-10">
                Marathon – Noida
              </div>

              {/* Certificate Content */}
              <div className="relative z-10 text-center mt-10">
                <h1 className="text-[#df670e] font-bold text-xl mb-1">Certificate of Participation</h1>
                <p className="text-sm">This is proudly presented to</p>
                <h2 className="font-semibold underline text-lg mt-1">
                  {certificateData.first_name} {certificateData.last_name}
                </h2>

                <div className="text-sm text-gray-600 mt-2">
                  <div><strong>Phone:</strong> {certificateData.phone}</div>
                  <div><strong>Address:</strong> {certificateData.address1}</div>
                </div>

                <p className="text-sm text-gray-700 mt-3 px-4 leading-snug">
                  For actively participating in the national initiative and promoting civic awareness through the <br />
                  <span className="font-semibold text-[#df670e]">"1 Nation 1 Election Marathon"</span>.
                </p>

                <div className="flex justify-between items-center text-xs mt-6 px-6">
                  <p className="border-t border-black w-2/5 text-center pt-1">Authorized Signature</p>
                  <p className="border-t border-black w-2/5 text-center pt-1">4 May 2025</p>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={downloadPDF}
            className="mt-6 bg-[#df670e] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#e65c1c] transition"
          >
            Download Certificate
          </button>
        </div>
      )}

    </Layout>
  );
};

export default Certificate;
